import { useEffect, useState } from "react"
import { Header } from "../../common/header/Header"
import { MenuAdmin } from "../MenuAdmin"
import { useNavigate, useParams } from "react-router-dom"
import { IFullCompanyDto } from "../../../types/company/IFullCompanyDto"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { ICountry } from "../../../types/dict/ICountry"
import { CountryPicker } from "../../common/element/fields/CountryPicker"
import { IErrorModel } from "../../../types/error/IErrorModel"
import { CommonInput } from "../../common/element/fields/CommonInput"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { ADMIN_COMPANY_ROUTE, getCompanyViewRoute } from "@/routes"
import Button from "@/ui/components/Button"
import { BanksTable } from "./Banks"
import { CommonFileInput } from "@/components/common/element/fields/CommonFileInput"
import { CommonFileList } from "@/components/common/element/fields/CommonFileList"
import { IB64File } from "@/types/IB64File"

export const CompanyAdmin = () => {
  const navigate = useNavigate()
  const params = useParams()

  const [company, setCompany] = useState<IFullCompanyDto>()
  const [errors, setErrors] = useState<IErrorModel>()
  const [sending, setSending] = useState(false)
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [isLoading, setLoading] = useState(false)
  const [files, setFiles] = useState<IB64File[]>([])

  const getCompany = () => {
    if (params.id) {
      TrinityAPI.getCompany(
        params.id,
        response => {
          if (response.status === 200) {
            setCompany(response.data)
          } else {
            setModalMessage({ title: "Ошибка!", text: "Ошибка получения компании: " + response.data.message })
          }
        },
        () => setLoading(false)
      )
    }
  }

  useEffect(() => {
    if (params.id && params.id !== "new") {
      getCompany()
    }
  }, [])

  const changeCountry = (countryList: ICountry[]) => {
    if (countryList.length === 0) {
      setCompany({ ...company, country: undefined })
    } else {
      setCompany({ ...company, country: countryList[0] })
    }
  }

  const changeExclusionCountry = (countryList: ICountry[]) => {
    if (countryList.length === 0) {
      setCompany({ ...company, countryExclusions: [] })
    } else {
      setCompany({ ...company, countryExclusions: countryList })
    }
  }

  const handleCompanySignChange = (file: IB64File) => {
    setCompany({ ...company, sign: file })
  }

  const handleCompanyStampChange = (file: IB64File) => {
    setCompany({ ...company, stamp: file })
  }

  const handleCompanyLogoChange = (file: IB64File) => {
    setCompany({ ...company, logo: file })
  }

  const submit = () => {
    if (sending || !company) return
    setSending(true)
    const submitCompany = { ...company }

    if (submitCompany?.id) {
      TrinityAPI.updateCompany(submitCompany, response => {
        if (response.status === 200) {
          setCompany({ ...company, id: response.data.id })
          setModalMessage({ title: "Инфо", text: "Компания обновлена" })
        } else {
          setErrors(response.data)
        }
        setSending(false)
      })
    } else {
      if (!submitCompany) {
        setModalMessage({ title: "Инфо", text: "Заполните обязательные поля" })
        setSending(false)
        return
      }
      TrinityAPI.createCompany(
        submitCompany,
        response => {
          if (response.status === 200) {
            setCompany({ ...company, id: response.data.id })
            setModalMessage({ title: "Инфо", text: "Компания создана" })
          } else {
            setErrors(response.data)
          }
        },
        () => setSending(false)
      )
    }
  }

  useEffect(() => {
    const newFiles = new Array<IB64File>()
    if (company?.stamp) {
      newFiles.push(company.stamp)
    }
    if (company?.sign) {
      newFiles.push(company.sign)
    }
    if (company?.logo) {
      newFiles.push(company.logo)
    }
    setFiles(newFiles)
  }, [company?.stamp, company?.sign, company?.logo])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <MenuAdmin active={"company"} />
      <section className="new-contragent">
        <Header />
        <div className="container">
          <h3 className="ui-heading">Зарубежные компании</h3>
          <div className="container-pop-up">
            <div className="form-left">
              <div className="form-block-popup">
                <h4 className="heading-chapter">Информация</h4>
                <CommonInput
                  typeName={"text"}
                  label={"Системное название"}
                  placeholder={"PT GAS"}
                  name={"shortName"}
                  value={company?.shortName}
                  errorModel={errors}
                  _callback={e => setCompany({ ...company, shortName: e })}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Юридическое название получателя средств"}
                  placeholder={"PT GEDE ARTHA SAMUDRA"}
                  name={"name"}
                  value={company?.name}
                  errorModel={errors}
                  _callback={e => setCompany({ ...company, name: e })}
                />
                <CountryPicker
                  label={"Юрисдикция"}
                  value={company?.country ? new Array(company.country) : []}
                  size={1}
                  name={"country"}
                  errorModel={errors}
                  _callback={changeCountry}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Адрес"}
                  placeholder={"Адрес компании"}
                  name={"address"}
                  value={company?.address}
                  errorModel={errors}
                  _callback={e => setCompany({ ...company, address: e })}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Специализация"}
                  placeholder={"Закупка котлованов под строительство"}
                  name={"okved"}
                  value={company?.okved}
                  errorModel={errors}
                  _callback={e => setCompany({ ...company, okved: e })}
                />
                <CountryPicker
                  label={"Страны исключения"}
                  size={20}
                  value={company?.countryExclusions ? company.countryExclusions : []}
                  name={"countryExclusions"}
                  errorModel={errors}
                  _callback={changeExclusionCountry}
                />
                <CommonInput
                  typeName={"text"}
                  label={"ФИО лица в счете"}
                  placeholder={"ФИО"}
                  name={"personName"}
                  value={company?.personName}
                  errorModel={errors}
                  _callback={e => setCompany({ ...company, personName: e })}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Должность лица в счете"}
                  placeholder={"Должность"}
                  name={"personPosition"}
                  value={company?.personPosition}
                  errorModel={errors}
                  _callback={e => setCompany({ ...company, personPosition: e })}
                />
              </div>
            </div>

            <div className="right-form">
              <div className="form-block-popup">
                <h4 className="heading-chapter">О компании</h4>
                <div className="flex-row-10">
                  <CommonFileInput
                    label={"Печать"}
                    placeholder={company?.stamp || company?.stampPath ? "Заменить" : "Загрузить"}
                    name={"stamp"}
                    errorModel={errors}
                    _callback={handleCompanyStampChange}
                  />
                  <CommonFileInput
                    label={"Подпись"}
                    placeholder={company?.sign || company?.signPath ? "Заменить" : "Загрузить"}
                    name={"sign"}
                    errorModel={errors}
                    _callback={handleCompanySignChange}
                  />
                </div>
                <div className="flex-row-10">
                  <CommonFileInput
                    label={"Логотип"}
                    placeholder={company?.logo || company?.logoPath ? "Заменить" : "Загрузить"}
                    name={"logo"}
                    errorModel={errors}
                    _callback={handleCompanyLogoChange}
                  />
                </div>
                <CommonFileList files={files} />
              </div>
            </div>

            <div className="width-full">
              <BanksTable
                banks={company?.banks}
                companyId={params.id || ""}
                isLoading={isLoading}
                refetch={getCompany}
              />
            </div>

            <div className="flex-row-24">
              <Button loading={sending} onClick={submit}>
                Сохранить
              </Button>
              {params.id && (
                <Button variant="grey" onClick={() => navigate(getCompanyViewRoute(params.id || ""))}>
                  Назад
                </Button>
              )}
              <Button variant="grey" onClick={() => navigate(ADMIN_COMPANY_ROUTE)}>
                К списку компаний
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
